<script lang="ts" xmlns="http://www.w3.org/1999/html">
import {defineComponent} from 'vue'
import SearchAutocompleteInput from '@/components/shared/SearchAutocompleteInput.vue'

export default defineComponent({
  name: "AppHomePage",
  components: { SearchAutocompleteInput },
  data() {
    return {
      searchTerm: '',
      placeholderText: 'Ապրանքի անվանումը կամ մոդելը'
    }
  },
  methods: {
    handleSearchButtonClick(value?: string) {
      const term = (value ?? this.searchTerm).trim()
      if (term.length > 0) {
        this.$router.push({ name: 'AppSearchPage', query: { query: term } })
      }
    }
  }
})
</script>

<template>
  <div class="min-h-screen flex items-center justify-center px-3 sm:px-0">
    <div class="w-full max-w-xl flex flex-col items-center mb-6">
      <app-link :to="{ name: 'AppHomePage' }" class="mb-6">
        <img src="@/assets/logo.png" class="h-10 md:h-16" alt="Online Markets logo" />
      </app-link>
      <div class="mb-6 text-center">
        <h1 class="font-semibold text-sm md:text-2xl">Բոլոր ապրանքների գները մեկ հարթակում</h1>
      </div>
      <div class="relative w-full mb-6">
        <search-autocomplete-input
          v-model="searchTerm"
          :placeholder="placeholderText"
          button-label="Որոնել"
          @search="handleSearchButtonClick"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
